import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { Eye, Users } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

const getSessionId = () => {
    let id = sessionStorage.getItem("drax_session");
    if (!id) {
        id =
            crypto.randomUUID?.() ||
            `s-${Date.now()}-${Math.random().toString(36).slice(2)}`;
        sessionStorage.setItem("drax_session", id);
    }
    return id;
};

export const LiveStats = () => {
    const [stats, setStats] = useState(null);
    const sessionId = useRef(null);

    useEffect(() => {
        sessionId.current = getSessionId();

        const post = (path) =>
            fetch(`${API}/api/analytics/${path}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ session_id: sessionId.current }),
            }).catch(() => {});

        const loadStats = () =>
            fetch(`${API}/api/analytics/stats`)
                .then((r) => r.json())
                .then(setStats)
                .catch(() => {});

        post("visit");
        loadStats();

        const heartbeat = setInterval(() => post("heartbeat"), 20000);
        const poll = setInterval(loadStats, 15000);
        return () => {
            clearInterval(heartbeat);
            clearInterval(poll);
        };
    }, []);

    if (!stats) return null;

    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.15, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="flex flex-wrap items-center gap-2.5"
            data-testid="live-stats-widget"
        >
            <span className="inline-flex items-center gap-2 rounded-full border border-[#222232] bg-[#14141E]/90 px-4 py-2 text-sm font-semibold text-[#94A3B8] shadow-lg shadow-black/40 backdrop-blur">
                <span className="h-2 w-2 rounded-full bg-[#25D366] animate-pulse-dot" />
                <Users className="h-4 w-4 text-[#25D366]" />
                <strong
                    className="font-display font-extrabold text-white"
                    data-testid="live-online-count"
                >
                    {stats.online_now}
                </strong>
                online agora
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-[#222232] bg-[#14141E]/90 px-4 py-2 text-sm font-semibold text-[#94A3B8] shadow-lg shadow-black/40 backdrop-blur">
                <Eye className="h-4 w-4 text-[#FF4757]" />
                <strong
                    className="font-display font-extrabold text-white"
                    data-testid="live-visits-count"
                >
                    {Number(stats.total_visits).toLocaleString("pt-BR")}
                </strong>
                visitas no site
            </span>
        </motion.div>
    );
};
